(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcent-component-feature-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var timelines = document.querySelectorAll('.dcent-feature-grid--timeline');
  if (!timelines.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  timelines.forEach(function (grid) {
    var line = grid.querySelector('.dcent-feature-grid__timeline');
    if (!line) return;
    var dots = Array.prototype.slice.call(line.querySelectorAll('.dcent-feature-grid__timeline-dot'));
    var n = dots.length || 1;
    grid.setAttribute('data-animate', '1');

    // 모바일 세로 레일 (MAGE-423 재검수) — 카드가 화면에 드는 순서대로 점·선을 채운다.
    // 데스크톱(≥1024)에서는 레일 pseudo 가 렌더되지 않아 is-lit 클래스가 무해하다.
    var railCards = Array.prototype.slice.call(grid.querySelectorAll('.dcent-feature-grid__card'));
    if (reduce || typeof IntersectionObserver !== 'function') {
      railCards.forEach(function (c) { c.classList.add('is-lit'); });
    } else {
      var railIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-lit');
            railIo.unobserve(en.target);
          }
        });
      }, { threshold: 0.5, rootMargin: '0px 0px -10% 0px' });
      railCards.forEach(function (c) { railIo.observe(c); });
    }

    function paint(p) {
      grid.style.setProperty('--dcent-fg-progress', p);
      dots.forEach(function (dot, i) {
        // design: dot lit when progress >= i/n (with a tiny epsilon so the first dot lights at 0)
        if (p >= i / n - 0.001) dot.classList.add('is-lit');
        else dot.classList.remove('is-lit');
      });
    }
    paint(0);

    if (reduce) { paint(1); return; }

    var raf = 0, timer = 0;
    var DELAY = 450, DUR = 2200;
    function run() {
      var start = 0;
      function tick(t) {
        if (!start) start = t;
        var p = Math.min(1, (t - start) / DUR);
        paint(p);
        if (p < 1) raf = requestAnimationFrame(tick);
      }
      timer = setTimeout(function () { raf = requestAnimationFrame(tick); }, DELAY);
    }
    function stop() { clearTimeout(timer); cancelAnimationFrame(raf); paint(0); }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) run();
        else stop();
      });
    }, { threshold: 0.3 });
    io.observe(grid);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dcent-component-logo-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tracks = document.querySelectorAll('[data-logo-marquee-track]');
  tracks.forEach(function (track) {
    if (track.dataset.logoCloned === '1') return;
    var originals = Array.from(track.children);
    if (!originals.length) return;

    var section = track.closest('[data-section-type="dcent-logo-marquee"]');
    var pace = section ? parseFloat(section.style.getPropertyValue('--dcent-logo-marquee-pace')) : 60;
    if (!pace || pace < 10) pace = 60;

    function appendSets(times) {
      for (var t = 0; t < times; t++) {
        originals.forEach(function (node) {
          var clone = node.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
      }
    }
    appendSets(1);
    track.dataset.logoCloned = '1';

    function pad() {
      var safety = 0;
      while (track.scrollWidth / 2 < window.innerWidth * 1.2 && safety < 20) {
        appendSets(2);
        safety++;
      }
    }
    function setPace() {
      var halfWidth = track.scrollWidth / 2;
      if (!halfWidth) return;
      var duration = Math.max(20, halfWidth / pace);
      track.style.animationDuration = duration.toFixed(1) + 's';
    }
    function init() { pad(); setPace(); }
    if (document.readyState === 'complete') init();
    else window.addEventListener('load', init);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setPace, 200);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dcent-component-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    var track = root.querySelector('.dcent-testimonial-carousel__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-review-slide]'));
    if (slides.length === 0) return;

    var prevBtn = root.querySelector('[data-review-prev]');
    var nextBtn = root.querySelector('[data-review-next]');
    var dotsWrap = root.querySelector('[data-review-dots]');
    var index = 0;

    // dot 인디케이터 — createElement/setAttribute만(마크업 문자열 주입 0).
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dcent-testimonial-carousel__dot';
        dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        dot.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function clamp(n) {
      var max = slides.length - 1;
      if (n < 0) return max;
      if (n > max) return 0;
      return n;
    }

    // 상태 반영(클래스·점)과 스크롤 이동을 분리한다 — 손 스와이프 동기화(아래)가
    // 상태만 갱신할 때 scrollTo 를 되부르면 스와이프 중에 트랙을 잡아채기 때문.
    function renderState() {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function render() {
      renderState();
      var target = slides[index];
      if (target) {
        track.scrollTo
          ? track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' })
          : (track.scrollLeft = target.offsetLeft);
      }
    }

    function go(n) { index = clamp(n); render(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(index - 1);
      else if (e.key === 'ArrowRight') go(index + 1);
    });

    // ── 손 스와이프 동기화 (MAGE-425) — 스크롤이 멎으면 가장 가까운 슬라이드를
    // 현재 인덱스로 되읽어 점 인디케이터가 따라온다(종전엔 버튼으로만 갱신됐다).
    var scrollTimer = 0;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (slide, i) {
          var d = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = i; }
        });
        if (nearest !== index) { index = nearest; renderState(); }
      }, 100);
    }, { passive: true });

    render();
  }

  // ── review 변종 무한 티커 (MAGE-542) ──────────────────────────────────────
  // 원본 Reviews.tsx 그대로: 2세트를 이어 붙인 스크롤 컨테이너를 rAF 로 프레임당 1px 씩
  // 왼쪽으로 흘리고, 반 세트 경계를 넘으면 한 세트 폭만큼 순간 이동해 양방향 무한 순환한다.
  // 종전 구현(5초마다 다음 카드로 점프)은 "자동으로 흐른다"가 아니라 슬라이드쇼였다.
  //   · 화살표 = 한 칸 이동 + 3초 정지. 손이 닿거나 마우스가 올라가면 멈춘다.
  //   · 점 인디케이터(모바일)는 세트가 아니라 **원본 후기 개수**(data-review-count)로 만든다 —
  //     슬라이드 수(2배)로 만들면 점이 20개가 된다.
  //   · reduced-motion 이면 흐르지 않는다(화살표·스와이프는 그대로).
  function initTicker(root) {
    var track = root.querySelector('.dcent-testimonial-carousel__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-review-slide]'));
    if (slides.length === 0) return;

    var baseCount = parseInt(root.getAttribute('data-review-count'), 10) || slides.length;
    var prevBtn = root.querySelector('[data-review-prev]');
    var nextBtn = root.querySelector('[data-review-next]');
    var dotsWrap = root.querySelector('[data-review-dots]');
    var paused = false;
    var resumeTimer = 0;
    var suppress = 0;
    var active = -1;

    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < baseCount; i++) {
        (function (idx) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dcent-testimonial-carousel__dot';
          dot.setAttribute('aria-label', 'Go to testimonial ' + (idx + 1));
          dot.addEventListener('click', function () { goTo(idx); });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        })(i);
      }
    }

    function step() {
      var first = slides[0];
      var w = first ? first.getBoundingClientRect().width : 0;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return w + gap;
    }
    function setWidth() { return step() * baseCount; }
    function normalize() {
      var w = setWidth();
      if (!w) return;
      if (track.scrollLeft < w * 0.5) track.scrollLeft += w;
      else if (track.scrollLeft >= w * 1.5) track.scrollLeft -= w;
    }
    function renderDots() {
      var s = step();
      if (!s) return;
      var n = baseCount;
      var idx = ((Math.round(track.scrollLeft / s) % n) + n) % n;
      if (idx === active) return;
      active = idx;
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === active); });
    }
    // 프로그램 스크롤(화살표·점) 중에는 경계 순간이동을 미룬다 — 스무스 스크롤이 되감기에
    // 끊기면 제자리로 보인다(DualStructure 패턴).
    function slideTo(target) {
      if (suppress) window.clearTimeout(suppress);
      suppress = window.setTimeout(function () { suppress = 0; normalize(); }, 600);
      if (track.scrollTo) track.scrollTo({ left: target, behavior: 'smooth' });
      else track.scrollLeft = target;
    }
    function pauseFor(ms) {
      paused = true;
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () { paused = false; }, ms);
    }
    function go(dir) {
      var s = step();
      if (!s) return;
      pauseFor(3000);
      normalize();
      slideTo((Math.round(track.scrollLeft / s) + dir) * s);
    }
    function goTo(i) {
      var s = step();
      if (!s) return;
      pauseFor(3000);
      normalize();
      var n = baseCount;
      var slot = Math.round((track.scrollLeft / s - i) / n) * n + i;
      slideTo(slot * s);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });

    track.addEventListener('scroll', function () {
      if (!suppress) normalize();
      renderDots();
    }, { passive: true });
    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('touchstart', function () {
      paused = true;
      if (resumeTimer) window.clearTimeout(resumeTimer);
    }, { passive: true });
    track.addEventListener('touchend', function () { pauseFor(4000); }, { passive: true });
    track.addEventListener('touchcancel', function () { pauseFor(4000); }, { passive: true });

    // 시작 위치 = 두 번째 세트 앞머리(뒤로도 흐를 수 있게)
    track.scrollLeft = setWidth();
    renderDots();

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;
    var visible = true;
    if (typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible = e.isIntersecting; });
      }, { threshold: 0 });
      io.observe(root);
    }
    var tick = function () {
      if (visible && !paused && !suppress) track.scrollLeft += 1;
      window.requestAnimationFrame(tick);
    };
    window.requestAnimationFrame(tick);
  }

  var roots = document.querySelectorAll('[data-testimonial-carousel]');
  Array.prototype.forEach.call(roots, function (root) {
    if (root.dataset.testimonialCarouselInit) return;
    root.dataset.testimonialCarouselInit = '1';
    if (root.closest('.dcent-testimonial-carousel--review')) initTicker(root);
    else initCarousel(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
